import { render } from "./product-info-overlay.vue?vue&type=template&id=1dd0a325"
import script from "./product-info-overlay.vue?vue&type=script&lang=js"
export * from "./product-info-overlay.vue?vue&type=script&lang=js"

import "./product-info-overlay.vue?vue&type=style&index=0&id=1dd0a325&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__